import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useField } from 'formik'
import { FieldInput } from '@/components/form'
import Context from '../context'

const EmailFieldInput = ({ autoFocus }) => {
  const { t } = useTranslation()
  const [field] = useField('username')
  const { value } = field
  const { setUsername, usernameClicked, setUsernameClicked } = useContext(Context)

  useEffect(() => {
    setUsername(value)
  }, [setUsername, value])

  return (
    <FieldInput
      name="username"
      type="email"
      autoFocus={autoFocus}
      placeholder={t('b.auth.view.email_or_phone.label', 'Email or phone number')}
      required
      hideError={!usernameClicked}
      onClick={() => setUsernameClicked(true)}
    />
  )
}

export default EmailFieldInput
